export default `
Please generate a simple word or phrase (no more than 4 words) to title the attached chatbot message(s).  Just return the phrase only.  No before or after messages...just a word or short phrase.
`;
